













































import { Vue, Component, Prop } from "vue-property-decorator";
import { Collapse, CollapseItem, Switch, Cell, CellGroup, Checkbox, CheckboxGroup, Popup, Picker, Overlay } from "vant";
import TrainPolicyService from "@/service/trainPolicyService";
import SystemService from "@/service/UserService";

import amendRule from "./amendRule.vue";
import * as _ from "lodash";
// import { FlightProductEntity, FlightGoodsEntity } from "../../../model/FlightPolicy";
import { dateDiff, DurationTime } from "@/utils/utils.ts";
import { RoleInfoEntity } from "../../../model/system";
import orderFrame from "../orderFrame.vue";
import dataShare from "../dataShare";
import { TrainPolicyEntity } from "@/model/Train";
import { sum } from "lodash";
import { ServiceType } from "@/model/Base";

@Component({
  name: "trainOrder",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Overlay.name]: Overlay,

    amendRule,
    orderFrame,
  },
  filters: {
    DurationTime,
  },
  methods: { dateDiff },
})
export default class extends Vue {
  // Products: FlightProductEntity[] = [];
  Products = [];
  // policys = [];
  // Goods: FlightGoodsEntity = {};
  Goods = {};
  isShowRule = false;
  // activeNames: string[] = [];
  // @Prop()
  // model: any;

  // @Prop()
  // consumers!: RoleInfoEntity[];

  // @Prop()
  policys: TrainPolicyEntity[] = [];

  get ServiceType() {
    return ServiceType.TrainService;
  }

  get ProductId() {
    return this.$route.query.ProductId;
  }
  get trainProductDetail() {
    return dataShare.ProductDetails;
  }

  mounted() {
    // this.$emit("getTitle", this.$root.$t("mall_train_trainorder_checixiangqing") as string);
    this.getInfoData();
  }

  formatDate(value: Date, format: string = this.$root.$t("mall_order_yueri1") as string) {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  //methods
  getInfoData() {
    const query = this.$route.query;
    const data = {
      // ApprovalRule: "",
      // CreateMode: "",
      // ChooseSeats: "",
      // OuterUserAct: "",
      // OuterUserPwd: "",
      // CenterID: "",
      // IntentID: "",
      // IntentName: "",
      // ProjectCode: "",
      // ContactName: "",
      // ContactPhone: "",
      // ContactEmail: "",
      // Remark: "",
      // Contrarys: [],
      // Consumers: [],
      // MailingAddress: { AddressID: "", Recipient: "", Address: "", Sex: "", ContactPhone: "", EmsCode: "" },
      ProductID: query.ProductId,
      ApplyArea: query.ApplyArea,
      BookingType: query.BookingType,
      ServiceType: query.ServiceType,
      TicketDelivery: 1450,
      RoomNum: 1,
      Extras: [{ ServiceType: 1466, ThrowID: "" }],
      TrainSeatNo: "",
      ContactEmailNotify: false,
      from_station: query.DepartCityCode,
      to_station: query.ArriveCityCode,
      train_date: "",
      seat_type: query.seatType,
      train_code: query.trainCode,
    };
    data.train_date = (this as any).$moment(query.DepartDate).format();
    TrainPolicyService.getProductInfo(data).then(res => {
      if (res.isSucc && res.result) {
        let policys = res.result as any;
        this.policys = policys;
        // this.$emit("loadPolicys", policys);
        this.Products = res.result[0].Products!;
        this.Goods = res.result[0].Goods![0];
        let policy: any = policys[policys.length - 1];
        // this.activeNames.push(policy.PolicyID);
      }
    });
  }

  totalPrices(label: string): number {
    let sumPrice = 0;
    if (!this.policys) return sumPrice;
    for (let i = 0; i < this.policys.length; i++) {
      const policy = this.policys[i];
      const goods = (policy as any).Goods[0];
      for (let p = 0; p < goods.Prices!.length; p++) {
        const price = goods.Prices![p];
        if (price.GroupCode == label) {
          sumPrice += price.MarketPrice;
        }
      }
    }
    return sumPrice;
  }

  // isStartStation(product: any) {
  //   let trainData = dataShare.ProductDetails;
  //   if (!trainData) {
  //     return "";
  //   }
  //   // console.log(trainData);
  //   if (trainData.start_station_name == trainData.from_station_name) {
  //     return this.$root.$t("mall_order_shifa");
  //   }
  //   return "经停";
  // }
}
